import { createContext, FC, useContext, ReactNode } from 'react';
import { useFragment, graphql } from 'react-relay';
import { useTranslationToggle, TranslationState } from 'dibs-elements/exports/useTranslationToggle';
import {
    PdpSharedOriginalLanguageProviderQuery,
    PdpSharedOriginalLanguageProviderQuery$data,
} from './__generated__/PdpSharedOriginalLanguageProviderQuery.graphql';
import { PdpSharedOriginalLanguageProvider_item$key } from './__generated__/PdpSharedOriginalLanguageProvider_item.graphql';

export { INTERFACE_STATE } from 'dibs-elements/exports/useTranslationToggle';

type Props = {
    item: PdpSharedOriginalLanguageProvider_item$key;
    children: ReactNode;
};
export type UseItemTranslationState = TranslationState<PdpSharedOriginalLanguageProviderQuery$data>;

export const OriginalLanguageContext = createContext<UseItemTranslationState>([null, null]);
export const PdpSharedOriginalLanguageProvider: FC<Props> = ({ children, item: itemRef }) => {
    const item = useFragment(
        graphql`
            fragment PdpSharedOriginalLanguageProvider_item on Item {
                serviceId
                sourceLocale
            }
        `,
        itemRef
    );
    const state = useTranslationToggle<PdpSharedOriginalLanguageProviderQuery>({
        sourceLocale: item.sourceLocale,
        query: graphql`
            query PdpSharedOriginalLanguageProviderQuery($itemId: String!) {
                viewer {
                    item(itemId: $itemId) {
                        title
                        description
                        seoDescription
                        pdpDetailsDisplay {
                            detailKey
                            detailValues {
                                detailKey
                                displayName
                                displayDetails
                            }
                        }
                        attributes {
                            customizable {
                                option {
                                    serviceId
                                }
                                text
                            }
                            ringResizable {
                                option {
                                    serviceId
                                }
                            }
                        }
                    }
                }
            }
        `,
        variables: { itemId: item.serviceId || '' },
    });

    return (
        <OriginalLanguageContext.Provider value={state}>
            {children}
        </OriginalLanguageContext.Provider>
    );
};

export function useItemTranslations(): UseItemTranslationState {
    return useContext(OriginalLanguageContext);
}
